<template>
  <div class="modal fade py-1" id="mod-campaign-add" role="dialog">
    <div
      class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
    >
      <div
        class="modal-content rounded-none bg-[#FCFCFD] py-[40px] px-[24px] min-h-screen"
      >
        <div class="modal-header flex items-start justify-between p-0 m-0">
          <h4
            class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[24px]"
          >
            Create New Campaign
          </h4>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="modal-body p-0 m-0">
          <div class="pb-[16px]">
            <label class="text=[#353535] font-bold text-[14px] leading-[20px]"
              >Name</label
            >
            <div>
              <input
                type="text"
                :class="[{ 'is-invalid': v1.name }]"
                v-model="campaign.name"
                class="border-[#d0d5dd] bg-transparent border-solid border-[1.5px] p-[12px] rounded-[8px] w-full outline-none"
                placeholder="Enter Campaign name"
              />
              <ul v-if="v1.name" class="parsley-errors-list filled">
                <li class="parsley-required">Required.</li>
              </ul>
            </div>
          </div>
          <div class="pb-[16px]">
            <label class="text=[#353535] font-bold text-[14px] leading-[20px]"
              >Type</label
            >
            <div>
              <select
                class="border-[#d0d5dd] bg-transparent border-solid border-[1.5px] p-[12px] rounded-[8px] w-full outline-none"
                placeholder="Select an option"
                v-model="campaign.type"
              >
                <option selected disable value="null"
                  >Select campaign type</option
                >
                <option v-for="t in types" :key="t" :value="t">
                  {{ t }}
                </option>
              </select>
              <ul v-if="v1.type" class="parsley-errors-list filled">
                <li class="parsley-required">Required.</li>
              </ul>
            </div>
          </div>
          <div class="pb-[16px]">
            <label class="text=[#353535] font-bold text-[14px] leading-[20px]"
              >Frequency</label
            >
            <div>
              <select
                class="border-[#d0d5dd] bg-transparent border-solid border-[1.5px] p-[12px] rounded-[8px] w-full outline-none"
                placeholder="Select an option"
                v-model="campaign.frequency"
              >
                <option selected disable value="null">Select frequency</option>

                <option v-for="f in frequencies" :key="f" :value="f">
                  {{ f }}
                </option>
              </select>
              <ul v-if="v1.frequency" class="parsley-errors-list filled">
                <li class="parsley-required">Required.</li>
              </ul>
            </div>
          </div>
          <div class="pb-[16px]">
            <label class="text=[#353535] font-bold text-[14px] leading-[20px]"
              >Message</label
            >
            <div>
              <textarea
                rows="3"
                class="border-[#d0d5dd] bg-transparent border-solid border-[1.5px] p-[12px] rounded-[8px] w-full outline-none"
                :class="[{ 'is-invalid': v1.message }]"
                v-model="campaign.message"
                placeholder="Enter campaign message here"
              ></textarea>
              <ul v-if="v1.message" class="parsley-errors-list filled">
                <li class="parsley-required">Required.</li>
              </ul>
            </div>
          </div>
          <div class="pb-[16px]">
            <label class="text=[#353535] font-bold text-[14px] leading-[20px]"
              >Start Date</label
            >
            <div>
              <input
                type="date"
                :class="[{ 'is-invalid': v1.starts }]"
                :min="minDate"
                placeholder="Select a date"
                v-model="campaign.starts"
                class="border-[#d0d5dd] bg-transparent border-solid border-[1.5px] p-[12px] rounded-[8px] w-full outline-none"
              />
              <ul v-if="v1.starts" class="parsley-errors-list filled">
                <li class="parsley-required">Required.</li>
              </ul>
            </div>
          </div>
          <div class="pb-[16px]">
            <label class="text=[#353535] font-bold text-[14px] leading-[20px]"
              >End Date</label
            >
            <div>
              <input
                type="date"
                :min="minDate"
                :class="[{ 'is-invalid': v1.ends }]"
                placeholder="Select a date"
                v-model="campaign.ends"
                class="border-[#d0d5dd] bg-transparent border-solid border-[1.5px] p-[12px] rounded-[8px] w-full outline-none"
              />
              <ul v-if="v1.ends" class="parsley-errors-list filled">
                <li class="parsley-required">Required.</li>
              </ul>
            </div>
          </div>
          <div
            class="flex items-center gap-[10px] max-w-max mb-[16px]"
            @click="campaign.active = !campaign.active"
          >
            <button
              type="button"
              class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer w-11 focus:outline-none"
              role="switch"
              :aria-checked="campaign.active"
              :class="{
                'bg-[#2463eb]': campaign.active,
                'bg-[#E4E4E7]': !campaign.active,
              }"
            >
              <span
                aria-hidden="true"
                class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform bg-gray-400 rounded-full pointer-events-none"
                :class="{
                  'translate-x-5 bg-white': campaign.active,
                  'translate-x-0 bg-gray-400': !campaign.active,
                }"
              ></span>
            </button>
            <span class="cursor-pointer">
              <span
                class="text-[#353535] text-[16px] font-normal leading-[20px]"
              >
                This Campaign is active
              </span>
            </span>
          </div>
        </div>
        <div class="flex items-center gap-[8px] w-full max-w-[500px] w-full">
          <button
            class="bg-transparent border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] font-medium leading-[20px] w-full outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
          >
            Cancel
          </button>

          <button
            @click.prevent="create"
            class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none disabled:cursor-not-allowed"
            type="button"
          >
            <i v-if="isBusy" class="fas fa-spinner fa-spin"></i>

            {{ isBusy ? "Loading..." : "Save Campaign" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Select2 from "@/components/Select2";
import SystemPermissions from "@/permissions";
import { helper } from "@/helper";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "campaignsCreate",
  components: {
    Select2,
  },
  data() {
    return {
      isBusy: false,
      campaign: {},
      types: ["Email", "SMS"],
      frequencies: ["Daily", "Weekly", "Monthly"],
      v1: {
        name: false,
        type: false,
        frequency: false,
        starts: false,
        ends: false,
      },
      options: {
        format: "YYYY-MM-DD",
        icons: {
          time: "mdi mdi-time",
          date: "mdi mdi-calendar",
          up: "mdi mdi-chevron-up",
          down: "mdi mdi-chevron-down",
          previous: "mdi mdi-chevron-left",
          next: "mdi mdi-chevron-right",
          today: "mdi mdi-screenshot",
          clear: "mdi mdi-trash",
          close: "mdi mdi-remove",
        },
      },
      local: {
        dow: 0, // Sunday is the first day of the week
        hourTip: "Select Hour", // tip of select hour
        minuteTip: "Select Minute", // tip of select minute
        secondTip: "Select Second", // tip of select second
        yearSuffix: "", // suffix of head year
        monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ), // months of head
        months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), // months of panel
        weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), // weeks
        cancelTip: "cancel",
        submitTip: "confirm",
      },
      maxDate: "",
      minDate: "",
    };
  },
  created() {
    if (!this.hasPermission("Campaign_Create")) {
      this.$router.push("/restricted");
    }
    this.initialize();
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
    this.minDate = helper.preventPastDateSelection();
  },
  methods: {
    initialize() {
      this.campaign = {
        name: null,
        type: null,
        frequency: null,
        starts: null,
        ends: null,
        active: false,
        message: null,
        parentId: this.user.parentId,
      };
    },
    async create() {
      this.isBusy = true;

      if (this.validateCampaign()) {
        await this.$http
          .post("/Campaigns/create", this.campaign)
          .then((res) => {
            this.isBusy = false;
            $("#mod-campaign-add").modal("hide");
            this.$emit("new-create");
          })
          .catch((error) => {
            console.error("Error creating campaign:", error);
            this.isBusy = false;
            this.$emit("new-create");
          });
      } else {
        this.isBusy = false;
      }
    },
    validateCampaign() {
      this.v1 = {
        name: false,
        type: false,
        frequency: false,
        starts: false,
        ends: false,
        message: false,
      };
      let isValid = true;

      if (!this.campaign.name) {
        this.v1.name = true;
        isValid = false;
      }

      if (!this.campaign.type) {
        this.v1.type = true;
        isValid = false;
      }

      if (!this.campaign.frequency) {
        this.v1.frequency = true;
        isValid = false;
      }

      if (!this.campaign.starts) {
        this.v1.starts = true;
        isValid = false;
      }

      if (!this.campaign.message) {
        this.v1.message = true;
        isValid = false;
      }

      if (!this.campaign.ends) {
        this.v1.ends = true;
        isValid = false;
      }

      return isValid;
    },
  },
};
</script>
